import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Box, Grid } from "@mui/material";
import { usersApi } from "../../../services/api";
import Loading from "../../../main/components/Loading";
import { UserDetailsHeader } from "../../users/components/UserDetailsHeader";
import { UserDetailsNotificationToggleItems } from "../../users/components/UserDetailsNotificationToggleItems";
import UserDetailsInfos from "../../users/components/UserDetailsInfos";
import EmptyStateNotFound from "../../clients/components/EmptyState";
import { NotificationConfiguration, User } from "../../users/types";
import { MainContext } from "../../../main/context/MainContextProvider";

export default function Perfil() {
  const [userDetails, setUserDetails] = useState<User | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const [notificationConfiguration, setNotificationConfiguration] = useState<
    NotificationConfiguration | undefined
  >();

  const { user } = useContext(MainContext);

  useEffect(() => {
    onMount();
  }, []);

  const onMount = async () => {
    setLoading(true);
    try {
      const userResponse = await usersApi.getUser(user?.userId || "");
      setUserDetails(userResponse);
      setNotificationConfiguration(userResponse.notificationConfiguration);
    } catch (error) {
      setUserDetails(null);
      if (axios.isAxiosError(error)) {
        ("Erro ao coletar os dados do usuário");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: loading ? "center" : "start",
        width: "100%",
        height: "100%",
        padding: { sm: "20px", xs: "10px" },
        rowGap: "20px",
      }}
    >
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {userDetails ? (
            <Grid
              container
              columnSpacing={2}
              padding={{
                xs: "10px",
                sm: "20px",
              }}
            >
              <UserDetailsHeader user={userDetails} onMount={onMount} />
              <UserDetailsInfos user={userDetails} onMount={onMount} />
              {notificationConfiguration && (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ padding: "none" }}
                  textAlign={"start"}
                >
                  <UserDetailsNotificationToggleItems
                    configuration={notificationConfiguration}
                    setConfiguration={setNotificationConfiguration}
                    label="Notificações"
                    defaultConfiguration={userDetails.notificationConfiguration}
                    userId={user?.userId || ""}
                    onMount={onMount}
                  />
                </Grid>
              )}

            </Grid>
          ) : (
            <EmptyStateNotFound />
          )}
        </>
      )}
    </Box>
  );
}
